module.exports = __webpack_public_path__ + "img/clothing9.f2341775.jpg";